import { useAppSelector } from '../hooks'

export const useTestsCountSelector = () => useAppSelector((state) => state.tests.count)
